import { render, staticRenderFns } from "./OwlCarousel.vue?vue&type=template&id=434b1248&"
import script from "./OwlCarousel.vue?vue&type=script&lang=js&"
export * from "./OwlCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports